import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-setting',
  templateUrl: './privacy-setting.component.html',
  styleUrls: ['./privacy-setting.component.scss']
})
export class PrivacySettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
